import { Component, OnInit, Output, EventEmitter, Input, OnChanges, TemplateRef, ViewChild, SecurityContext } from '@angular/core';
import { PHBHPFeaturePackageConfigurationService } from "../ph-bhp-feature-package-configuration.service";
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-configure-turorialmanagement',
  templateUrl: './ph-bhp-configure-turorialmanagement.component.html',
  styleUrls: ['./ph-bhp-configure-turorialmanagement.component.css']
})
export class PhBhpConfigureTurorialmanagementComponent implements OnInit {
  @Input() userData: any;
  isCollapsed: [boolean] = [false];
  tutorialDetails: any[];
  fileurl: any;
  filetitle;
  customClass;
  filetype: any;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  deleteDataItem
  deleterowIndex
  searchText: string;
  @Output() changeLanguage = new EventEmitter();
  @Input() isDesktop = true;
  subscription: Subscription;

  emitData: any = {
    key: "",
    val: ""
  }

  config = {
    class: 'modal-full pdfFullview'

  }
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(private service: PHBHPFeaturePackageConfigurationService, private modalService: BsModalService, public layoutService: PHBHPLayoutPackageService, private sanitizer: DomSanitizer, private router: Router) { }

  ngOnInit() {
    this.getTutorials();
    this.subscription = this.layoutService.lang.asObservable().subscribe(() => {
      this.getTutorials();
    })
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe()
  }

  getTutorials() {
    this.service.getTutorials().subscribe((res: any[]) => {
      this.tutorialDetails = res.filter(x => x.language === localStorage.getItem('selectedlanguage'));
    });
  }

  delete() {
    this.service.deleteTutorial(this.deleteDataItem).subscribe((res: [any]) => {
      this.getTutorials();
    });
  }

  openDeleteModal(deletemodal: TemplateRef<any>, tutorialId) {
    this.deleteDataItem = tutorialId
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  openModal(template: TemplateRef<any>, fileURL, fileType, filetitle) {
    this.filetype = fileType;
    this.filetitle = filetitle
    if (fileType === 'pdf') {
      fileURL = fileURL + '#toolbar=0';
      this.customClass = 'pdfModal modal-full pdfFullview';
    } else {
      this.customClass = 'vedioModal modal-full pdfFullview';
    }
    //this.fileurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizer.sanitize(SecurityContext.URL, this.data.serverUrl + fileURL));
    this.fileurl = this.layoutService.serverUrl + fileURL;

    this.modalRef = this.modalService.show(template, Object.assign({}, this.config, { class: this.customClass }));

  }


  emitTutorialData(key: any, value: any) {

    this.onChildData({ key: key, val: value });
  }
  onChildData(emitter) {

    switch (emitter.key) {
      case 'edit':
        this.router.navigate(['/configure/tutorial/edit/' + emitter.val]);
        break;
      case 'add':
        this.router.navigate(['/configure/tutorial/' + emitter.key]);
        break;
    }
  }
  // duplicateData(sopId, key){

  //  this.service.CloneSOP(sopId, this.userData.userId).subscribe((res:any)=>{
  //   this.childData.emit({key:key,val:res.sopid});
  //  });
  // }

  // duplicateVersion(sopId,stepsVersionID, key){

  //  this.service.CloneStepVersionSOP(sopId, this.userData.userId,stepsVersionID).subscribe((res:any)=>{
  //   this.childData.emit({key:key,val:res.sopid});
  //  });
  // }

  addTutorial() {
    this.emitData = {};
    this.emitData.key = 'add';
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }
}
